<template>
	<div class="eventium-box-background" :data-event-type="skin">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 340 120"
			preserveAspectRatio="none"
		>
			<defs>
				<pattern
					id="paper-pattern-x"
					patternUnits="userSpaceOnUse"
					width="1000"
					height="1000"
				>
					<image :href="pathTextures + '/marble-texture-bg.avif'" />
				</pattern>
				<linearGradient
					id="eventium-gradient-1"
					x1="170"
					y1="120"
					x2="170"
					y2="0"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0"
						:stop-color="`${skins.get(skin)?.color1}`"
					/>
					<stop
						offset="1"
						:stop-color="`${skins.get(skin)?.color2}`"
					/>
				</linearGradient>
				<linearGradient
					id="eventium-gradient-2"
					x1="170"
					y1="120"
					x2="170"
					y2="0"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset=".35" stop-color="#bd9032" />
					<stop offset=".65" stop-color="#f0d386" />
				</linearGradient>
			</defs>
			<g id="Layer_57">
				<path
					class="cls-2"
					d="M340,30v60c-16.56,0-30,13.43-30,30H30c0-16.57-13.43-30-30-30V30C16.57,30,30,16.57,30,0h280c0,16.57,13.44,30,30,30Z"
				/>
				<path
					class="cls-2-texture"
					d="M340,30v60c-16.56,0-30,13.43-30,30H30c0-16.57-13.43-30-30-30V30C16.57,30,30,16.57,30,0h280c0,16.57,13.44,30,30,30Z"
				/>
				<path
					class="cls-1"
					d="M307.82,2.26c1.11,15.99,13.93,28.81,29.92,29.92v55.64c-15.99,1.11-28.81,13.93-29.92,29.92H32.18c-1.11-15.99-13.93-28.81-29.92-29.92v-55.64c15.99-1.11,28.81-13.93,29.92-29.92h275.64M310,0H30c0,16.57-13.43,30-30,30v60c16.57,0,30,13.43,30,30h280c0-16.57,13.44-30,30-30V30c-16.56,0-30-13.43-30-30h0Z"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts" setup>
import { EventCategory } from "@/types/ui";
import { pathTextures } from "@/utils/url";

interface Props {
	skin: EventCategory;
}

const { skin = EventCategory.CHRISTMAS } = defineProps<Props>();

const skins = new Map<string, Record<string, string>>([
	[
		EventCategory.CHRISTMAS,
		{
			color1: "#7c0824",
			color2: "#bd002e",
		},
	],
	[
		EventCategory.FISHING,
		{
			color1: "#123611",
			color2: "#8eaf1f",
		},
	],
	[
		EventCategory.EASTER,
		{
			color1: "#e2c798",
			color2: "#e2c798",
		},
	],
	[
		EventCategory.FIREFEST,
		{
			color1: "#e2c798",
			color2: "#e2c798",
		},
	],
	[
		EventCategory.SOLAR,
		{
			color1: "#e2c798",
			color2: "#e2c798",
		},
	],
	[
		EventCategory.HUNTING,
		{
			color1: "#123611",
			color2: "#8eaf1f",
		},
	],
	[
		EventCategory.HALLOWEEN,
		{
			color1: "#e2c798",
			color2: "#e2c798",
		},
	],
	[
		EventCategory.PIRATES,
		{
			color1: "#e2c798",
			color2: "#e2c798",
		},
	],
]);
</script>

<style lang="scss" scoped>
.eventium-box-background {
	display: flex;
	position: relative;
	z-index: 0;
	width: 100%;
	height: 100%;

	.cls-1 {
		fill: url(#eventium-gradient-2);
	}
	.cls-2 {
		fill: url(#eventium-gradient-1);
		&-texture {
			mix-blend-mode: multiply;
			fill: url(#paper-pattern-x);
		}
	}
}
</style>
